import { NgModule } from '@angular/core';
import { AgentStatusPipe } from './queue-calls-status-pipe.pipe';

@NgModule({
   declarations: [AgentStatusPipe],
   exports: [AgentStatusPipe],
})
export class AgentStatusPipeModule {}
